import * as React from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

const Highlights = ({ highlights }) => {
  //console.log(highlights);
  if (highlights && highlights.highlight) {
    return (
      <div className="content">
        <div className="columns is-multiline">
          {highlights.highlight.map((highlight) => {
            if (
              highlight.image &&
              highlight.image.childImageSharp &&
              highlight.image.childImageSharp.resize &&
              highlight.image.childImageSharp.resize.src
            ) {
              highlight.image = highlight.image.childImageSharp.resize.src;
            }

            return (
              <div className="is-parent column is-4" key={nanoid()}>
                {highlight.image ? (
                  <PreviewCompatibleImage
                    imageInfo={{
                      image: highlight.image,
                      alt: highlight.title,
                      class: "highlight-image",
                    }}
                  />
                ) : null}
                <h3>{highlight.title}</h3>

                <p className="hidden">{highlight.summary}</p>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

Highlights.propTypes = {
  highlights: PropTypes.object,
};

export default Highlights;
